module.exports = __webpack_public_path__ + "img/toplogo.3fd43ace.png";